import { Modal } from 'react-bootstrap';
import FormBenhAnBody from '../../components/modal-benh-an/content';
import FormBenhAnHeader from '../../components/modal-benh-an/header';

type Props = {
	open: boolean;
	onClose: () => void;
	patientInfo?: any;
	disabled?: boolean;
};

const ModalBenhAnNoiTru = ({ open, onClose, patientInfo, disabled }: Props) => {
	return (
		<Modal
			className="page-full"
			fullscreen
			dialogClassName="h-modal"
			show={open}
			animation={false}
			backdropClassName="spaces top-50"
		>
			<Modal.Header className="py-3 header-modal">
				<FormBenhAnHeader onClose={onClose} benhNhanInfo={patientInfo} />
			</Modal.Header>
			<Modal.Body className="px-0 py-6 spaces overflow-hidden h-calc-vh-90">
				<FormBenhAnBody disabled={disabled} />
			</Modal.Body>
		</Modal>
	);
};

export default ModalBenhAnNoiTru;
